import { Boxes } from 'lucide-react';

import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const RawMaterialCategoryEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={Boxes}
      title="No hay categorías de materia prima"
      description="Cree grupos como carnes, vegetales, lácteos o empaques para organizar los insumos de recetas, producción e inventario."
      hint="Use Nueva categoría para crear el primer grupo"
    />
  );
};

export default RawMaterialCategoryEmpty;
